import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { buildImageSource, buildImageSourceSet } from '../../../utils/buildImageSource';
import { Flex } from '../../layout/Flex';
import { Image } from '../../media/Image';
import { MediaCover } from '../../media/MediaCover';
import { Typography } from '../../typography/Typography';
import { AdvertisingCopyButton } from './parts/AdvertisingCopyButton/AdvertisingCopyButton';
import { AdvertisingMoreButton } from './parts/AdvertisingMoreButton/AdvertisingMoreButton';
import { AdvertisingProductCardPrice } from './parts/AdvertisingProductCardPrice/AdvertisingProductCardPrice';
import { AdvertisingProductCardSource } from './parts/AdvertisingProductCardSource/AdvertisingProductCardSource';
import { LinkOverlay, Wrapper } from './styles';
import { AdvertisingProductCardProps } from './types';

export const AdvertisingProductCard: React.FC<AdvertisingProductCardProps> = ({
    name,
    offers,
    image,
    price,
    onMoreButtonClick: onMoreButtonClickBase,
    ...other
}) => {
    const isMultipleOffer = offers.length > 1;
    const firstOffer = offers[0];

    const onMoreButtonClick = useCallback(() => {
        onMoreButtonClickBase?.(offers);
    }, [offers, onMoreButtonClickBase]);

    return (
        <Wrapper {...other}>
            {isMultipleOffer ? null : <LinkOverlay as={Link} to={firstOffer.url} target="_blank" />}
            <MediaCover
                ratio={1}
                overflow="hidden"
                borderRadius="24px"
                border="solid 4px transparent"
                backgroundColor="unset"
                width="100%"
                height="185px"
            >
                <Flex alignItems="center" justifyContent="center" backgroundColor="white">
                    <Image
                        objectFit="contain"
                        width="100%"
                        height="100%"
                        src={buildImageSource(image)}
                        srcSet={buildImageSourceSet(image)}
                    />
                </Flex>
            </MediaCover>
            <Flex px={1} pb={1} width="100%" spacing={0.25}>
                <Typography variant="body2" width="100%" lines={2} textTransform="capitalize">
                    {name}
                </Typography>
                <AdvertisingProductCardPrice offers={offers} price={price} />
                <AdvertisingProductCardSource offers={offers} />
            </Flex>
            <Flex justifySelf="flex-end" width="100%" mt="auto" px={0.5} pb={0.5}>
                {isMultipleOffer ? (
                    <AdvertisingMoreButton onClick={onMoreButtonClick} />
                ) : (
                    <AdvertisingCopyButton url={firstOffer.url} zIndex={2} />
                )}
            </Flex>
        </Wrapper>
    );
};
